import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getAllProjects } from "../../../services/projectService";

export const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true);

      const data = await getAllProjects({
        page: 1,
        limit: 10,
      });

      setProjects(data?.projects ?? []);
    } catch (error) {
      console.error(error);
      toast.error("Không thể tải danh sách dự án");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return {
    projects,
    loading,
    refetch: fetchProjects,
  };
};